import { Injectable, inject } from '@angular/core';

import { Actions } from '@ngrx/effects';

import { createEffectFactory } from '@core/ngrx-legacy';

import { FieldMappingActions } from './field-mapping.store';

@Injectable({ providedIn: 'root' })
export class FieldMappingEffects {
  private readonly actions$ = inject(Actions);

  public effect = createEffectFactory(FieldMappingActions, this.actions$);
}
